export var BUTTON_DIMENSION = 34;
export var BUTTON_SHADOW_SIZE = 5;
